// Fades in each homepage/page section as it scrolls into view.
// The first section (hero) is skipped so above-the-fold content is visible immediately.
const sections = Array.from(document.querySelectorAll('main .shopify-section'));
const targets = sections.slice(1);

if (targets.length > 0) {
  targets.forEach((el) => el.classList.add('scroll-reveal'));

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('scroll-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -80px 0px' }
    );

    targets.forEach((el) => observer.observe(el));
  } else {
    targets.forEach((el) => el.classList.add('scroll-reveal--visible'));
  }
}
